﻿

export enum Projections {
    WGS = 'EPSG:4326',
    WebMercator = 'EPSG:3857'
}